export default function generateReactKey(): number {
    return Math.floor(Math.random() * 0xffffffff)
}
